// extracted by mini-css-extract-plugin
export default {"labelSplit":"styles_labelSplit__IkhsE","applyLabel":"styles_applyLabel__FPyt+","inputHeight":"styles_inputHeight__h+DsX"};